import plyr from 'plyr';

export default {
	init() {
		const player = new plyr('#home-vid', {
			hideControls: false, 
			captions: {
				active: true,
			},
		});

		console.log(player)

		player.toggleControls(false)
		player.on('play', function() {
			player.toggleControls(true);
		});

		window.player = player;


		// video player
		// $('#home-vid').click( function() {	

		// 	const el = $(this);
		// 	const video = el.get(0);
		
		// 	if (video.paused) {
		// 		video.play();
		// 	} else {
		// 		video.pause();
		// 	}

		// 	bar(el)
		// 	return false;

		// });

		// function bar(vid) {
		// 	var progBar = vid.siblings('.progressBar'),
		// 		timebar = progBar.children('.timeBar');

		// 	// progress bar update on video play

		// 	vid.on('timeupdate', function() {	
		// 		var vidDuration = vid[0].duration,
		// 			vidProgress = vid[0].currentTime,
		// 			percentage = vidProgress / vidDuration * 100;

		// 		timebar.css('width', percentage + '%');
		// 	});

		// 	// progress bar drag & click

		// 	var timeDrag = false;

		// 	progBar.mousedown(function(e) {
		// 		timeDrag = true;
		// 		updatebar(e.pageX);
		// 	});

		// 	$(document).mouseup(function(e) {
		// 		if(timeDrag) {
		// 			timeDrag = false;
		// 			updatebar(e.pageX);
		// 		}
		// 	});

		// 	$(document).mousemove(function(e) {
		// 		if(timeDrag) {
		// 			updatebar(e.pageX);
		// 		}
		// 	});
			
		// 	function updatebar(x) {
		// 		var maxduration = vid[0].duration,
		// 			position = x - progBar.offset().left,
		// 			percentage = 100 * position / progBar.width();

		// 		if(percentage > 100) {
		// 			percentage = 100;
		// 		}

		// 		if(percentage < 0) {
		// 			percentage = 0;
		// 		}
				
		// 		timebar.css('width', percentage+'%');
		// 		vid[0].currentTime = maxduration * percentage / 100;
		// 	}
		// }


	},
	finalize() {
	// JavaScript to be fired on the home page, after the init JS
	},
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js